import React from 'react';
import cx from 'classnames';

import Modal from '~/components/modals/modal';
import { useShedData } from '~/components/the-shed/use-shed-data';
import { useFiltering } from '~/hooks/use-filtering';

import styles from '~/components/modals/shed-filters/shed-filters-modal.module.scss';
import modalStyles from '~/components/modals/modal.module.scss';

const ShedFiltersModal = ({ isOpen, onClose }) => {
  const { data } = useShedData({ enabled: isOpen });
  const { filterValues, setFilter, clearAllFilters } = useFiltering(
    data?.articles,
    {
      category: (article, activeCategories) => {
        return (
          activeCategories.includes(article.category.articleCategory.slug) ||
          activeCategories.includes(article.category.articleSubCategory?.slug)
        );
      },
      tag: (article, activeTags) => {
        return article.tags?.find(
          (tag) => Boolean(tag) && activeTags.includes(tag.slug)
        );
      },
    }
  );

  if (!data?.categories || !data?.tags) {
    return null;
  }

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      className={modalStyles.shedFilters}
    >
      <section className={styles.tagItems}>
        <div className={styles.filterHeader}>
          <h3 className={styles.filterHeaderText}>Filter Articles</h3>
          <button
            className={styles.clearButton}
            onClick={clearAllFilters}
            type="button"
          >
            Clear all
          </button>
        </div>

        <div className={styles.tagContainer}>
          <p className={styles.tagHeader}>Category</p>
          <div className={styles.tagBlock}>
            {data?.categories.map((category) => {
              const filterMatch = filterValues.category.includes(category.slug);
              return (
                <button
                  className={cx(styles.tag, {
                    [styles.selected]: filterMatch,
                  })}
                  key={category.name}
                  onClick={() => setFilter('category', category.slug)}
                  type="button"
                >
                  {category.name}
                  {filterMatch && (
                    <svg width="10" height="10" fill="none">
                      <path
                        d="m9.667 1.273-.94-.94L5.001 4.06 1.274.333l-.94.94L4.061 5 .334 8.727l.94.94L5.001 5.94l3.726 3.727.94-.94L5.941 5l3.726-3.727Z"
                        fill="#fff"
                      />
                    </svg>
                  )}
                </button>
              );
            })}
          </div>
        </div>

        <div className={styles.tagContainer}>
          <p className={styles.tagHeader}>Tag</p>
          <div className={styles.tagBlock}>
            {data?.tags.map((tag) => {
              const filterMatch = filterValues.tag.includes(tag.slug);
              return (
                <button
                  className={cx(styles.tag, {
                    [styles.selected]: filterMatch,
                  })}
                  key={tag.name}
                  onClick={() => setFilter('tag', tag.slug)}
                  type="button"
                >
                  {tag.name}
                  {filterMatch && (
                    <svg width="10" height="10" fill="none">
                      <path
                        d="m9.667 1.273-.94-.94L5.001 4.06 1.274.333l-.94.94L4.061 5 .334 8.727l.94.94L5.001 5.94l3.726 3.727.94-.94L5.941 5l3.726-3.727Z"
                        fill="#fff"
                      />
                    </svg>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      </section>
    </Modal>
  );
};

export default ShedFiltersModal;
